import { Input, Output, EventEmitter, OnChanges } from "@angular/core";
import { UIListModel } from "e5core-angular-services";
import { CategorizationChangeEvent } from "../../../events/categorization-change-event";


export class E5coreUiCategorizationBase implements OnChanges {

  @Input() categorization:number[] ;
  @Input() labels: string[] ;
  @Input() readonly: boolean ;
  @Input() cat1List: UIListModel[] ;  
  @Input() cat2List: UIListModel[] ;
  @Input() cat3List: UIListModel[] ;
  @Input() hideToLevel: number ;

  @Output() catChange = new EventEmitter<CategorizationChangeEvent>() ;

  // selCat1Id:number ;
  // selCat2Id:number ;
  // selCat3Id:number ;

  cat1Value : string ;
  cat2Value : string ;
  cat3Value : string ;

  onChange() {
    this.catChange.emit( <CategorizationChangeEvent> {
      category1Id : this.categorization[0] | 0,
      category2Id : this.categorization[1] | 0,
      category3Id : this.categorization[2] | 0
    })
  }

  ngOnChanges() {
    let cat = (this.cat1List) ? (this.cat1List.find( i => i.id == this.categorization[0])) : null ;
    this.cat1Value = cat ? cat.label : undefined ;
    cat = (this.cat2List) ? (this.cat2List.find( i => i.id == this.categorization[1])) : null ;
    this.cat2Value = cat ? cat.label : undefined ;
    cat = (this.cat3List) ? (this.cat3List.find( i => i.id == this.categorization[2])) : null ;
    this.cat3Value = cat ? cat.label : undefined ;
  }
}
